<template>
  <div class="container-fluid">
    <v-card
      color="red"
      flat
      tile
    >
      <v-toolbar dense
                 src="https://i.pinimg.com/originals/99/15/6e/99156e46ab6f1974d4e0d9cc9460ce68.jpg"
      >
        <v-spacer></v-spacer>
        <v-dialog
          v-model="editDialog"
          width="800"
          persistent
        >
          <template
            v-slot:activator="{ on, attrs }"
            v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
          >
            <v-btn
              color="white"
              dark
              v-bind="attrs"
              v-on="on"
              outlined
              @click="editedItem = defaultItem"
            >
              Přidat jídelníček
            </v-btn>
          </template>
          <DietForm
            :item="editedItem"
            @formCanceled="editDialog = false"
            v-if="editDialog"
            :foodTypes="foodTypes"
            @data-saved="getDiets"
          ></DietForm>
        </v-dialog>
        <v-dialog
          v-model="printDialog"
          width="800"
        >
         <PrintDietForm v-if="printDialog" :diet-id="dietToPrintId" :time-types="timeTypes"></PrintDietForm>
        </v-dialog>
      </v-toolbar>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="diets"
      sort-by="dietType"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      locale="cs"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Jídelníčky</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-switch
            v-model="showOnlyActive"
            label="Pouze aktivní"
            @change="filterDiets"
            hide-details
            inset
            dense
            class="mr-4"
          >
          </v-switch>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="toggleActive(item)"
          v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
        >
          {{item.active ? 'mdi-sleep' : 'mdi-sleep-off'}}
        </v-icon>
        <v-icon
          small
          class="mr-2"
          @click="editDietContent(item)"
        >
          mdi-clipboard-list-outline
        </v-icon>
        <v-icon
          small
          @click="printDiet(item)"
        >
          mdi-printer
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    <v-dialog
      persistent
      v-model="addToDietDialog"
      max-width="1700"
    >
      <v-card>
        <AddToDiet
          @formCanceled="addToDietDialog = false"
          v-if="addToDietDialog"
          :diet="editedItem"
        ></AddToDiet>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DietForm from '../../components/forms/admin/DietForm'
import AddToDiet from './AddToDiet'
import { mapGetters } from 'vuex'
import PrintDietForm from '@/components/forms/admin/PrintDietForm'
export default {
  Name: 'Dietgroups',
  components: { PrintDietForm, AddToDiet, DietForm },
  data: () => ({
    // datatable
    loading: true,
    showOnlyActive: true,
    diets: [],
    search: '',
    headers: [
      {
        text: 'Název',
        align: 'start',
        sortable: true,
        value: 'name'
      },
      { text: 'Typ jídelníčku', value: 'dietType' },
      { text: 'Typ stravy', value: 'foodTypesStr' },
      { text: 'Platnost od', value: 'dateFrom' },
      { text: 'Platnost do', value: 'dateTo' },
      { text: 'Cena rozvozu', value: 'deliveryPrice' },
      { text: 'Cena balení', value: 'packagePrice' },
      { text: 'Minimální cena objednávky', value: 'minPrice' },
      { text: 'Akce', value: 'actions', sortable: false }
    ],

    // editing / creating
    editDialog: false,
    editedItem: {},
    defaultItem: {
      id: null,
      name: '',
      foodTypes: null,
      dateFrom: new Date().toISOString().substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      time: null,
      minPrice: '',
      deliveryPrice: '',
      packagePrice: '',
      ordersClosing: null,
      dayBeforeArr: [false, false, false, false, false, false, false]
    },
    foodTypes: [],
    timeTypes: [],

    // adding to diet
    addToDietDialog: false,

    // printing
    dietToPrintId: null,
    printDialog: false
  }),
  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.$http.get('/admin/food-types')
        .then(response => {
          this.foodTypes = this.keysToCamelCase(response.data)
            .filter(type => type.active)
        })
        .catch(err => console.log(err))
      this.$http.get('/admin/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
            .filter(type => type.active)
        })
      this.getDiets()
    },

    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    },
    toggleActive (item) {
      this.$http.put(`/admin/diets/${item.id}`, this.keysToSnakeCase({
        ...item,
        active: +!item.active
      }))
        .then(response => {
          this.getDiets()
        })
        .catch(err => {
          console.log(err)
        })
    },
    editDietContent (item) {
      this.editedItem = Object.assign({}, item)
      this.addToDietDialog = true
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.diets[this.editedIndex], this.editedItem)
      } else {
        this.diets.push(this.editedItem)
      }
      this.close()
    },
    getDiets () {
      this.editDialog = false
      this.loading = true
      this.$http.get('/admin/diets')
        .then(response => {
          this.diets = this.keysToCamelCase(response.data)
            .map(diet => {
              diet.foodTypesStr = diet.foodTypes
                .map(type => type.name)
                .join(', ')

              diet.dayBefore = diet.universalClosing ? diet.dietDeadlines[0].dayBefore : false
              diet.dayBeforeArr = diet.ordersClosingArr ? diet.ordersClosingArr.map(deadline => deadline.dayBefore) : [false, false, false, false, false, false]
              diet.ordersClosingArr = diet.dietDeadlines
              return diet
            })
          if (this.showOnlyActive) {
            this.diets = this.diets.filter(diet => !!diet.active)
          }
          this.loading = false
        })
        .catch(err => { console.log(err) })
    },
    filterDiets () {
      if (this.showOnlyActive) {
        this.diets = this.diets.filter(diet => !!diet.active)
      } else {
        this.initialize()
      }
    },
    printDiet (diet) {
      this.dietToPrintId = diet.id
      this.printDialog = true
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'user/currentUser' })
  }
}
</script>

<style scoped>
</style>
